import { useEffect, useState } from "react";
import NumberComparisonDropdown from "../../dropdowns/numberComparison.dropdown.advancedQuery";

const FORM_FIELDS = {
  comparison: "eq",
  numberValue: "",
  secondValue: "",
};

const NumberInput = ({ field: { label, value } = {}, setMatch = () => {} }) => {
  const [formFields, setFormFields] = useState(FORM_FIELDS);
  const { comparison, numberValue, secondValue } = formFields;

  const handleChange = ({ target: { name, value } }) => {
    setFormFields((prevFields) => ({ ...prevFields, [name]: value }));
  };

  const updateFormFieldsBasedOnComparison = () => {
    let updates = {};
    if (secondValue && secondValue < numberValue) {
      updates.secondValue = numberValue;
    }
    if (comparison !== "between" && secondValue) {
      updates.secondValue = "";
    }
    setFormFields((prevFields) => ({ ...prevFields, ...updates }));
  };

  const updateMatch = () => {
    const comparisonOps = {
      eq: numberValue,
      lt: { $lt: numberValue },
      gt: { $gt: numberValue },
      between: { $gt: numberValue, $lt: secondValue },
    };
    const operation = comparisonOps[comparison] || numberValue;

    setMatch((prevMatch) => {
      const [key, matchValue] = Object.entries(prevMatch)[0];
      return {
        [key]: matchValue.map((fieldVal) =>
          value === Object.keys(fieldVal)[0]
            ? { [Object.keys(fieldVal)[0]]: operation }
            : fieldVal
        ),
      };
    });
  };

  useEffect(updateFormFieldsBasedOnComparison, [
    numberValue,
    secondValue,
    comparison,
  ]);
  useEffect(updateMatch, [formFields]);
  return (
    <div className="justify-between bg-slate-100 p-2 flex-wrap gap-2 flex flex-row shadow shadow-secondary">
      <h3 className="font-bold">{label}:</h3>
      <div className="flex-wrap flex flex-row gap-2">
        <NumberComparisonDropdown
          handleChange={handleChange}
          name="comparison"
          value={comparison}
        />

        <input
          type="number"
          onChange={handleChange}
          placeholder="Enter a value..."
          name="numberValue"
          value={numberValue}
          className="w-32 rounded px-2 shadow shadow-secondary"
          max={secondValue}
        />
        {comparison === "between" && (
          <div className="flex flex-row gap-2">
            <label className="px-2 rounded shadow shadow-secondary">{`< ${label} <`}</label>
            <input
              type="number"
              onChange={handleChange}
              placeholder="Enter a value..."
              name="secondValue"
              value={secondValue}
              className="w-32 rounded px-2 shadow shadow-secondary"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NumberInput;
